import AbstractService from "./AbstractService";

export default class MinibusService extends AbstractService {
  url(url) {
    return `/minibusManagement${url}`;
  }

  create(request) {
    return this.http.post(this.url("/create"), request);
  }

  createReservation(request) {
    return this.http.post(this.url("/addReservation"), request);
  }

  // update(data) {
  //   return this.http.put(this.url("/"), data);
  // }

  getCheckedMinibus(requestRef) {
    return this.http.get(this.url(`/requests/getCheckedMinibuses/${requestRef}`))
  }

  checkConflict(request) {
    const params = request;
    return this.http.get(this.url("/checkConflict/getConflict"), { params });
  }

  reservationsCheckConflict(request) {
    const params = request;
    return this.http.get(this.url("/checkConflict/reservationConflict"), { params });
  }

  checkConflictExcludeRef(request) {
    const params = request;
    return this.http.get(this.url("/checkConflict/excludeRefCheckConflict"), { params });
  }

  reservationsCheckConflictExcludeRef(request) {
    const params = request;
    return this.http.get(this.url("/checkConflict/reservationConflictexcludeRef"), { params });
  }
  
  deleteReservationByMinibusRefAndRequestRef(request) {
    const params = request;
    return this.http.delete(this.url("/query/deleteReservationByMinibusRefAndRequestRef"), { params });
  }

  updateReservationByMinibusRefAndRequestRef(request) {
    return this.http.put(this.url("/query/updateReservationByMinibusRefAndRequestRef"), request);
  }

  findAll(reference, query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
  
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url(`/getAll`), {
      params
    });
  }

  findAllReservation(reference, query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
  
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url(`/getReservations`), {
      params
    });
  }

}
